import { trpc } from '@/lib/trpc';

export function useAvatarUrl() {
  const { data: profile } = trpc.profile.getProfile.useQuery(undefined, {
    staleTime: 5 * 60 * 1000,
  });

  const { data: avatarData } = trpc.profile.getAvatarUrl.useQuery(undefined, {
    enabled: !!profile?.hasAvatar,
    retry: false,
    staleTime: 50 * 60 * 1000, // presigned URL lasts 1h, refresh at 50min
  });

  return avatarData?.url ?? null;
}
